import { useLocation } from "react-router-dom";
import Results from "../components/gameResults/results";

export default function GameResultsPage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const type = params.get("type"); // ligue / teams / sports
  const sport = params.get("sport"); // soccer / tenis
  const idEvent = params.get("idEvent");
  const version= params.get("country");

  return (
    <Results type={type} sport={sport} idEvent={idEvent} version={version}/>
  )

}